import { PermissionsModel, User } from '@/models/user.model'
import { api } from '@/services/api'

type FetchOperatorsParams = {
  companyId: string
  ownerId: string
  isWork?: boolean
}

export type FetchOperatorsResponse = {
  operators: User[]
}

export async function fetchOperators(params: FetchOperatorsParams) {
  const customParams = `?companyId=${params.companyId}&ownerId=${params.ownerId}${
    params.isWork !== undefined && `&isWork=${params.isWork}`
  }`
  const response = await api.get<FetchOperatorsResponse>(`/users/operators${customParams}`)
  return response.data
}

type FetchUserPermissionParams = {
  companyId: string
  role: string
}

export type FetchUserPermissionResponse = {
  permission: PermissionsModel
}

export async function fetchUserPermission(params: FetchUserPermissionParams) {
  const response = await api.get<FetchUserPermissionResponse>(`/users/permissions`, {
    params
  })
  return response.data
}

type UpdatePasswordDTO = {
  email: string
  password: string
}

export async function updatePassword(dto: UpdatePasswordDTO) {
  const response = await api.post(`/user/update-password`, dto)
  return response.data
}

type UpdateUserDTO = {
  id: string
  dataToUpdate: Partial<User>
}

export async function updateUser(dto: UpdateUserDTO) {
  const response = await api.put(`/users`, dto)
  return response.data
}
